import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-multi-priceyard-panel',
  templateUrl: './multi-priceyard-panel.component.html',
  styleUrls: ['./multi-priceyard-panel.component.scss']
})
export class MultiPriceyardPanelComponent implements OnInit , OnDestroy {
  _selectedSkus: any;
  get selectedSkus() {
    return this._selectedSkus;
  }
  @Input() set selectedSkus(value) {
    this._selectedSkus = value;
  }
  private destroy$ = new Subject<void>();
  constructor() { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
